import { Injectable } from '@angular/core';
import { Actions, Effect, ofType } from '@ngrx/effects';
import { select, Store } from '@ngrx/store';
import { filter, map, withLatestFrom } from 'rxjs/operators';
import * as fromRoot from '../../reducers';
import { getNotificationsState } from '../selectors/notifications';
import {
  ActionTypes,
  AppendNotification,
  MarkAllSeen,
  MarkUnitRoomSeen,
  UpdateNotifications,
  UpdateSelectedApplicationUnread,
} from '../actions/notifications';
import { NotificationsState } from '../reducers/notifications';

@Injectable()
export class NotificationsEffects {
  constructor(
    private actions$: Actions,
    private store: Store<fromRoot.State>
  ) {}

  @Effect()
  markAllSeen = this.actions$.pipe(
    ofType<MarkAllSeen>(ActionTypes.MarkAllSeen),
    withLatestFrom(
      this.store.pipe<NotificationsState>(select(getNotificationsState))
    ),
    map(([action, state]) => {
      const seenNotifications = state.notifications.map(notification => {
        notification.seen = true;
        return notification;
      });

      return new UpdateNotifications({
        notifications: seenNotifications,
      });
    })
  );

  @Effect()
  markUnitRoomSeen = this.actions$.pipe(
    ofType<MarkUnitRoomSeen>(ActionTypes.MarkUnitRoomSeen),
    withLatestFrom(
      this.store.pipe<NotificationsState>(select(getNotificationsState))
    ),
    map(([action, state]) => {
      const roomSeenNotifications = state.notifications.map(notification => {
        if (notification.unit_room === action.payload) {
          notification.seen = true;
          notification.read = true;
          return notification;
        }
        return notification;
      });
      return new UpdateNotifications({
        ...state,
        notifications: roomSeenNotifications,
        selectedApplicationUnread: 0,
      });
    })
  );

  @Effect()
  appendNotification = this.actions$.pipe(
    ofType<AppendNotification>(ActionTypes.AppendNotification),
    withLatestFrom(
      this.store.pipe<NotificationsState>(select(getNotificationsState))
    ),
    map(([action, state]) => {
      const newNotifications = state.notifications;
      newNotifications.unshift(action.payload);

      return new UpdateNotifications({
        notifications: newNotifications,
      });
    })
  );

  @Effect()
  UpdateSelectedApplicationUnread = this.actions$.pipe(
    ofType<UpdateSelectedApplicationUnread>(
      ActionTypes.UpdateSelectedApplicationUnread
    ),
    withLatestFrom(
      this.store.pipe<NotificationsState>(select(getNotificationsState))
    ),
    map(([action, state]) => {
      let count = 0;

      for (const notification of state.notifications) {
        if (
          notification.application === action.payload &&
          notification.read === false
        ) {
          count++;
        }
      }

      return new UpdateNotifications({
        selectedApplicationUnread: count,
      });
    })
  );
}
